const DietQuery = {
  full: 'name level label shortLabel restrictedIngredients',
}

export default DietQuery
